export function tableDragScroll() {
  const wrappers = document.querySelectorAll(".table-scroll-wrapper");
  if (!wrappers.length) return;

  wrappers.forEach((wrapper) => {
    let isDown = false;
    let startX;
    let scrollLeft;

    wrapper.addEventListener("mousedown", (e) => {
      isDown = true;
      wrapper.style.cursor = "grabbing";
      startX = e.pageX - wrapper.offsetLeft;
      scrollLeft = wrapper.scrollLeft;
    });

    wrapper.addEventListener("mouseleave", () => {
      isDown = false;
      wrapper.style.cursor = "grab";
    });

    wrapper.addEventListener("mouseup", () => {
      isDown = false;
      wrapper.style.cursor = "grab";
    });

    wrapper.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - wrapper.offsetLeft;
      const walk = (x - startX) * 1.5;
      wrapper.scrollLeft = scrollLeft - walk;
    });

    wrapper.style.cursor = "grab";
  });
}